import { useEffect } from 'react';
import { PhoneValue } from '../../types';

type MakeValueReturn = unknown;

type Data = {
  makeValue: (value: null, code: PhoneValue['isoCode']) => MakeValueReturn;
  onChange: (value: MakeValueReturn) => void;
  valueProp: PhoneValue;
  codesListItemsExists: boolean;
};

export const useValueReset = ({
  makeValue,
  onChange,
  valueProp,
  codesListItemsExists
}: Data) => {
  useEffect(() => {
    if (valueProp.isoCode && !valueProp.number && codesListItemsExists) {
      const defaultValue = makeValue(null, valueProp.isoCode);

      onChange?.(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueProp.isoCode, codesListItemsExists]);
};
